import { useEffect } from 'react';
import { connect } from 'redux-bundler-react';
import { ToastContainer } from 'react-toastify';

import Hero from '@components/hero';
import Footer from '@components/footer';
import PageContent from '@components/page-content';
import LoadingModal from './common/modals/loading';
import LandingModal from './common/modals/LandingModal';
import NavBar from '@components/navigation';
import Modal from './app-components/modal/primary-modal/PrimaryModal';
import SecondaryModal from './app-components/modal/secondary-modal/SecondaryModal';
import { initOnlineListener } from './app-pages/data-entry/offline/online-listener';
import SyncBanner from './app-pages/data-entry/offline/sync-banner/SyncBanner';
import { usePwaMode } from './app-pages/data-entry/offline/pwa-mode';

import 'react-toastify/dist/ReactToastify.css';
import './css/bootstrap/css/bootstrap.water.min.css';
import '@styles/index.scss';
import '@styles/uswds-theme/_uswds-theme-components.scss';
import '@styles/_buttons.scss';
import 'ag-grid-community/dist/styles/ag-grid.css';
import 'ag-grid-community/dist/styles/ag-theme-balham.css';
import 'ag-grid-community/dist/styles/ag-theme-balham-dark.css';

export default connect(
  'doGetAllLookupData',
  'doModalOpen',
  'selectRoute',
  'selectAuth',
  'selectLoadingState',
  'selectLoadingMessage',
  ({ doGetAllLookupData, doModalOpen, route: Route, auth, loadingState, loadingMessage }) => {
    const isAuthenticated = !!auth?.token;
    const offlineAuthenticated = !!auth?.offlineAuthenticated;
    const userHasRole = !!auth?.authData?.role;
    const pwaMode = usePwaMode();
    const openApp = isAuthenticated || (pwaMode && !navigator.onLine && offlineAuthenticated);

    useEffect(() => {
      const cleanupOnlineListener = initOnlineListener();

      if (isAuthenticated && userHasRole && navigator.onLine) {
        doGetAllLookupData();
      } else if (!openApp) {
        const landingModalSeen = sessionStorage.getItem('landingModalSeen');
        if (!landingModalSeen || landingModalSeen === 'false') {
          doModalOpen(LandingModal);
        }
      }

      return cleanupOnlineListener;
    }, [doGetAllLookupData, isAuthenticated, userHasRole, doModalOpen, openApp]);

    return (
      <div className='page'>
        {loadingState && <LoadingModal text={loadingMessage} />}
        <ToastContainer autoClose={3500} hideProgressBar={false} />
        {(!pwaMode || !openApp) && <NavBar />}
        {openApp && <SyncBanner />}
        <PageContent className='main'>{openApp ? <Route /> : <Hero />}</PageContent>
        <Modal closeWithEscape />
        <SecondaryModal closeWithEscape />
        <Footer />
      </div>
    );
  }
);
